import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/case-actions';
import { CaseActions, OrderActions } from '../constants';
import { ICase } from 'src/types/case';

export interface CaseState {
    inProgress: boolean;
    inProgressOther: boolean;
    inProgressAll: boolean;
    authCode: string;
    error: string;
    data: Paginated<ICase>;
    statementDocs: Paginated<any>;
    dataOther: Paginated<ICase>;
    miniLoaderFor: { [key: string]: boolean };
    current: ICase | null;
    caseNumbers: { [key: string]: string | null }[];
    caseNumbersStudent: { [key: string]: string | null }[];
    currentFiles: any | null;
    isDouble: any;
}

const initialState = {
    inProgress: false,
    inProgressOther: false,
    inProgressAll: false,
    authCode: '',
    error: '',
    isDouble: false,
    caseNumbers: [],
    caseNumbersStudent: [],
    miniLoaderFor: {},
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    statementDocs: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    dataOther: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    current: null,
    currentFiles: null,
};

export function cases(state: CaseState = initialState, action: Actions | any): CaseState {
    switch (action.type) {
        case 'RESET_DOUBLE':
            return { ...state, isDouble: false };
        case requestType(CaseActions.PERSIST_CASE):
            return { ...state, error: '', inProgress: true, isDouble: false };
        case successType(CaseActions.PERSIST_CASE):
            return { ...state, inProgress: false, isDouble: false };
        case failureType(CaseActions.PERSIST_CASE):
            return { ...state, inProgress: false, isDouble: false };

        case requestType(CaseActions.CASE_NUMBERS):
            return { ...state, error: '', inProgress: true };
        case successType(CaseActions.CASE_NUMBERS):
            return { ...state, caseNumbers: action.payload, inProgress: false };
        case failureType(CaseActions.CASE_NUMBERS):
            return { ...state, inProgress: false };

        case requestType(CaseActions.CASE_NUMBERS_STUDENT):
            return { ...state, error: '', inProgress: true };
        case successType(CaseActions.CASE_NUMBERS_STUDENT):
            return { ...state, caseNumbersStudent: action.payload, inProgress: false };
        case failureType(CaseActions.CASE_NUMBERS_STUDENT):
            return { ...state, inProgress: false };

        case requestType(CaseActions.CREATE_STATEMENT):
            return { ...state, error: '', inProgress: true };
        case successType(CaseActions.CREATE_STATEMENT):
            return { ...state, inProgress: false };
        case failureType(CaseActions.CREATE_STATEMENT):
            return { ...state, error: action.error, inProgress: false };
        case requestType(CaseActions.FETCH_CASES_ANOTHER):
            return {
                ...state,
                dataOther: {
                    ...state.dataOther,
                    list: [],
                    page: 1,
                    meta: state.dataOther?.meta,
                    inProgress: true,
                },
                error: '',
                inProgressOther: true,
            };

        case successType(CaseActions.FETCH_CASES_ANOTHER):
            return {
                ...state,
                dataOther: { ...action.payload, inProgress: false },
                inProgressOther: false,
            };
        case failureType(CaseActions.FETCH_CASES_ANOTHER):
            return {
                ...state,
                error: action.error,
                dataOther: { ...state.dataOther, inProgress: false },
                inProgressOther: false,
            };

        case requestType(CaseActions.FETCH_CASES):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(CaseActions.FETCH_CASES):
            return {
                ...state,
                data: { ...action.payload, inProgress: false },
                inProgress: false,
                inProgressAll: false,
            };
        case failureType(CaseActions.FETCH_CASES):
            return {
                ...state,
                data: { ...state.data, inProgress: false },
                error: action.error,
                inProgress: false,
                inProgressAll: false,
            };

        case requestType(CaseActions.FETCH_CASES_SIMPLY):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(CaseActions.FETCH_CASES_SIMPLY):
            return {
                ...state,
                data: { ...action.payload, inProgress: false },
                inProgress: false,
                inProgressAll: false,
            };
        case failureType(CaseActions.FETCH_CASES_SIMPLY):
            return {
                ...state,
                data: { ...state.data, inProgress: false },
                error: action.error,
                inProgress: false,
                inProgressAll: false,
            };

        case requestType(CaseActions.FETCH_CHECK_CASES):
            return {
                ...state,
                inProgress: true,
                isDouble: false,
            };
        case successType(CaseActions.FETCH_CHECK_CASES):
            return { ...state, inProgress: false, isDouble: action.payload.isDouble };
        case failureType(CaseActions.FETCH_CHECK_CASES):
            return { ...state, inProgress: false };

        case requestType(CaseActions.FETCH_STATEMENT_DOCS):
            return {
                ...state,
                statementDocs: {
                    ...state.statementDocs,
                    list: [],
                    page: 1,
                    inProgress: true,
                    meta: state.statementDocs?.meta?.updatedAt
                        ? state.statementDocs?.meta
                        : {
                              updatedAt: null,
                          },
                },
                error: '',
                inProgress: true,
                inProgressAll: true,
            };
        case successType(CaseActions.FETCH_STATEMENT_DOCS):
            return {
                ...state,
                statementDocs: { ...action.payload, inProgress: false },
                inProgress: false,
                inProgressAll: false,
            };
        case failureType(CaseActions.FETCH_STATEMENT_DOCS):
            return {
                ...state,
                statementDocs: { ...state.statementDocs, inProgress: false },
                error: action.error,
                inProgress: false,
                inProgressAll: false,
            };
        case requestType(CaseActions.FETCH_CASE):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(CaseActions.FETCH_CASE):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(CaseActions.FETCH_CASE):
            return { ...state, inProgress: false, error: action.error };
        case requestType(CaseActions.DELETE_CASE):
            return { ...state, error: '', inProgress: true };
        case successType(CaseActions.DELETE_CASE):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: ICase) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(CaseActions.DELETE_CASE):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        case requestType(CaseActions.FETCH_FILES_CASE):
            return { ...state, error: '', miniLoaderFor: { FILE: true } };
        case successType(CaseActions.FETCH_FILES_CASE):
            return { ...state, miniLoaderFor: {}, currentFiles: action.payload };
        case failureType(CaseActions.FETCH_FILES_CASE):
            return { ...state, miniLoaderFor: {}, error: action.error };
        case requestType(CaseActions.DELETE_FILE_CASE):
            return { ...state, error: '', miniLoaderFor: { FILE: true } };
        case successType(CaseActions.DELETE_FILE_CASE):
            const { sagaPayload } = action;
            const curNewFiles = (state.currentFiles ?? []).filter((file: any) => file.id !== sagaPayload.id);

            return {
                ...state,
                miniLoaderFor: {},
                currentFiles: curNewFiles,
            };
        case failureType(CaseActions.DELETE_FILE_CASE):
            return { ...state, miniLoaderFor: {}, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case successType(CaseActions.CREATE_FILES_CASE):
            const curFiles = [...(state.currentFiles ?? [])];
            curFiles.push(action.payload);

            return {
                ...state,
                miniLoaderFor: {},
                currentFiles: curFiles,
            };
        case requestType(CaseActions.CREATE_FILES_CASE):
            return { ...state, error: '', miniLoaderFor: { FILE: true } };
        case failureType(CaseActions.CREATE_FILES_CASE):
            return { ...state, miniLoaderFor: {}, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        default:
            return state;
    }
}
